/////////////MENU MOBILE////////////////////
document.addEventListener("DOMContentLoaded", function () {
  const menuIcon = document.querySelector(".menu-icon");
  const menu = document.querySelector(".menu");
  const icon = document.querySelector(".menu-icon .icon");

  if (menuIcon && menu && icon) {
    menuIcon.addEventListener("click", () => {
      // Alternar la clase 'open' en el ícono
      menuIcon.classList.toggle("open");

      // Alternar la visibilidad del menú
      menu.classList.toggle("active");

      // Cambiar el contenido del ícono entre hamburguesa y "X"
      if (menuIcon.classList.contains("open")) {
        icon.innerHTML = "✕";  // Cambiar a "X"
      } else {
        icon.innerHTML = "&#9776;";  // Cambiar a hamburguesa
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const workLink = document.getElementById("work-link");

  function updateLink() {
    if (window.innerWidth <= 800) {
      // Para dispositivos móviles (800px o menos)
      workLink.setAttribute("href", "#cases2");
    } else {
      // Para dispositivos de escritorio (mayores de 800px)
      workLink.setAttribute("href", "#cases");
    }
  }

  // Llama a la función para actualizar el enlace al cargar la página
  updateLink();

  // Llama a la función cada vez que se cambie el tamaño de la ventana
  window.addEventListener("resize", updateLink);
});







//ANIMACIÓN HOLA/////////////////////
var h1 = document.querySelector("section.hola h1");
if (h1) {
    var textos = ["hello", "hola", "Ciao", "Hallo", "álo", "bonjour", "Привет"];
    var indice = 0;

    function changeText() {
        gsap.to(h1, {
            opacity: 0,
            duration: 0.15,
            onComplete: function() {
                h1.textContent = textos[indice];
                indice = (indice + 1) % textos.length;
                gsap.to(h1, { opacity: 1, duration: 0.5 });
            }
        });
    }
    setInterval(changeText, 1000); // Ajusta el intervalo si es necesario
} else {
    console.error("Elemento h1 en sección .hola no encontrado.");
}

//VIDEO MASK ///////////////////////////////////////////////
const videoh = document.getElementById('VideoHero');

    // Espera a que los metadatos del video se carguen
    videoh.addEventListener('loadedmetadata', function() {
        // Establece el tiempo de inicio 
        videoh.currentTime = 20;
        videoh.play();
    });


const button = document.querySelector('section.video-section div.mask button');
const mask = document.querySelector('section.video-section div.mask');
const video = document.querySelector('section.video-section .videoup video');

button.addEventListener('click', () => {
    // Ocultar el botón
    button.style.display = 'none';

    // Aplicar la clase para el efecto de zoom y desvanecimiento
    mask.classList.add('hidden');

    // Reiniciar el video y activar sonido
    video.pause();
    video.currentTime = 0; // Reinicia el video
    video.muted = false; // Activa el sonido
    video.play(); // Reproduce el video
});
 

//////WHAT WE DO PATTERN/////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", () => {
    const canvas = document.getElementById("backgroundCanvas");
    const ctx = canvas.getContext("2d");
canvas.style.zIndex = 0
    // Configuración del canvas
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const fontSize = 24; // Tamaño de las letras
    const spacing = 30; // Espaciado entre las letras
    const letters = []; // Array para las letras

    // Crear una cuadrícula de letras (X o O)
    for (let y = spacing; y < canvas.height; y += spacing) {
        for (let x = spacing; x < canvas.width; x += spacing) {
            // Asignar letra aleatoria y decidir si será azul o no
            letters.push({
                char: Math.random() > 0.5 ? "X" : "O", // Aleatorio entre X y O
                x: x,
                y: y,
                isBlue: Math.random() < 0.1 // Aproximadamente el 10% de las letras serán azules
            });
        }
    }

    // Dibujar letras en el canvas
    function drawLetters() {
        ctx.clearRect(0, 0, canvas.width, canvas.height); // Limpiar el canvas
        ctx.font = `${fontSize}px Arial`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        letters.forEach(letter => {
            // Cambiar color si la letra es azul
            ctx.fillStyle = letter.isBlue ? "#036DC4" : "#262827"; // Azul si es la letra seleccionada
            ctx.fillText(letter.char, letter.x, letter.y);
        });
    }

    // Cambiar las letras aleatoriamente cada 200ms
    setInterval(() => {
        letters.forEach(letter => {
            letter.char = Math.random() > 0.5 ? "X" : "O"; // Cambiar aleatoriamente entre X y O
            // Aleatoriamente cambiar si la letra será azul
            letter.isBlue = Math.random() < 0.007; // Aproximadamente el 10% de las letras se vuelven azules
        });
        drawLetters(); // Redibujar las letras con las nuevas
    }, 200); // Intervalo de 200ms

    // Redimensionar canvas dinámicamente
    window.addEventListener("resize", () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        letters.length = 0; // Vaciar el array de letras
        for (let y = spacing; y < canvas.height; y += spacing) {
            for (let x = spacing; x < canvas.width; x += spacing) {
                // Asignar letra aleatoria y decidir si será azul o no
                letters.push({
                    char: Math.random() > 0.5 ? "X" : "O", // Aleatorio entre X y O
                    x: x,
                    y: y,
                    isBlue: Math.random() < 0.1 // Aproximadamente el 10% de las letras serán azules
                });
            }
        }

        drawLetters();
    });

    // Dibujar letras inicialmente
    drawLetters();
});


//////////////Discover/////////////////////////////////////////////
let number = 0;
import stampG from '../images/stamp G.png';
import stampH from '../images/stamp H.png';
import stampI from '../images/stamp I.png';
import stampJ from '../images/stamp J.png';
import stampK from '../images/stamp K.png';
import stampL from '../images/stamp L.png';

let stamps = [stampG, stampH, stampI, stampJ, stampK, stampL];


const stampTag = document.querySelector("div.stamps");

// Función para agregar una stamp
const addStamp = function (x, y) {
    const img = document.createElement("img");
    img.setAttribute("src", stamps[number]);
    img.style.left = (x - window.innerWidth / 2) + "px";
    img.style.top = y + "px";

    stampTag.appendChild(img);

    const audio = document.createElement("audio");
    audio.setAttribute("src", "plop.mp3");
    audio.play();

    number = number + 1;
    if (number > stamps.length - 1) {
        number = 0;
    }
};

// Generar automáticamente las stamps
let count = 0;
const generateStamps = () => {
    const interval = setInterval(() => {
        if (count >= 15) {
            clearInterval(interval);
            return;
        }
        
        // Generar coordenadas aleatorias dentro de la ventana
        const x = Math.random() * window.innerWidth;
        const y = Math.random() * window.innerHeight;

        addStamp(x, y);
        count++;
    }, 1000); // 
};

generateStamps();



/////CAROUSLE 2 //////////////////////////////////////////////////////////////////////////////

let z = 1; // Control de profundidad
let current = 0; // Índice inicial
const images = document.querySelectorAll(".slides img");
const viewImageButton = document.querySelector(".split button");
const lightbox = document.getElementById("lightbox");
const lightboxImg = document.getElementById("lightboxImg");
const closeLightbox = document.querySelector("#lightbox .close");

// Función para detectar dispositivos móviles
function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

// Solo agregar eventos si no es un dispositivo móvil
if (!isMobileDevice()) {
  images.forEach((slide) => {
    slide.addEventListener("click", function () {
      z = z + 1;

      let direction = "150%";
      let midAngle = 15;

      if (Math.random() > 0.5) {
        direction = "-150%";
        midAngle = -15;
      }

      const currentImage = images[current];

      const flipTimeline = gsap.timeline();

      flipTimeline
        .set(currentImage, {
          x: 0,
          rotation: midAngle,
          rotate: 20,
          scale: 1.2,
        })
        .to(currentImage, { x: direction })
        .set(currentImage, { zIndex: z })
        .to(currentImage, {
          x: 0,
          rotation: () => 16 * Math.random() - 8,
          rotate: 0,
          scale: 1,
        });

      current = (current + 1) % images.length;
    });
  });
}

// Mostrar la imagen actual al hacer clic en "View Image"
viewImageButton.addEventListener("click", () => {
    // Restamos 1 al índice actual para compensar la actualización anticipada
    const adjustedIndex = current === 0 ? images.length - 1 : current - 1;
    const currentImageSrc = images[adjustedIndex].src;
    lightboxImg.src = currentImageSrc;
    lightbox.classList.remove("hidden");
  });
  

// Cerrar el lightbox
closeLightbox.addEventListener("click", () => {
  lightbox.classList.add("hidden");
});









////// SCROLL HORIZONTAL///////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.horizontal-scroll-container');

    window.addEventListener('wheel', (e) => {
        if (e.deltaY !== 0) {
            container.scrollLeft += e.deltaY;
            e.preventDefault();
        }
    });
});


///// POP UP///////////////////////////////////////////////////////////////
        // Obtener los elementos
const popupForm = document.getElementById('popupForm');
const popupBackground = document.getElementById('popupBackground');
const popupButtons = document.querySelectorAll('.popupButton');
const closeButton = document.querySelector('.close-btn');

// Función para abrir el pop-up
function abrirPopup(buttonId) {
  popupForm.style.display = 'block';
  popupBackground.style.display = 'block';
}

// Asignar evento de click a cada botón
popupButtons.forEach(button => {
  button.addEventListener('click', function () {
    abrirPopup();
  });
});

// Función para cerrar el pop-up
closeButton.addEventListener('click', function () {
  popupForm.style.display = 'none';
  popupBackground.style.display = 'none';
});

// Cerrar el pop-up al hacer clic fuera del formulario
popupBackground.addEventListener('click', function () {
  popupForm.style.display = 'none';
  popupBackground.style.display = 'none';
});


////////////////////////// Carousel Mobile///////////////
// Importar imágenes
import img1 from '../images/Caso-Club-del-Constructor.jpg';
import img2 from '../images/Caso-Dulce-Navidad.jpg';
import img3 from '../images/Caso-Familia-Alboroto.jpg';
import img4 from '../images/Caso-Yo-doy-la-Talla.jpg';
import img5 from '../images/PRIMO-CASE.jpg';

// Crear el array de imágenes
const carouselImages = [img1, img2, img3, img4, img5];

let currentIndex = 0; // Índice actual de la imagen

// Elementos del DOM
const currentImage = document.getElementById('currentImage'); // Imagen principal
const prevButton = document.querySelector('.prev'); // Botón anterior
const nextButton = document.querySelector('.next'); // Botón siguiente


// Función para actualizar la imagen del carrusel
function updateImage(index) {
  currentImage.src = carouselImages[index];
}

// Inicializar la primera imagen
updateImage(currentIndex);

// Evento: Botón 'Prev'
prevButton.addEventListener('click', () => {
  currentIndex = (currentIndex - 1 + carouselImages.length) % carouselImages.length; // Cicla al inicio
  updateImage(currentIndex);
});

// Evento: Botón 'Next'
nextButton.addEventListener('click', () => {
  currentIndex = (currentIndex + 1) % carouselImages.length; // Cicla al final
  updateImage(currentIndex);
});

// Evento: Click en la imagen principal para abrir Lightbox
currentImage.addEventListener('click', () => {
  lightbox.classList.remove('hidden');
  lightboxImg.src = carouselImages[currentIndex];
});

// Evento: Botón cerrar del Lightbox
closeLightbox.addEventListener('click', () => {
  lightbox.classList.add('hidden');
});

// Cerrar Lightbox al hacer clic fuera de la imagen
lightbox.addEventListener('click', (e) => {
  if (e.target === lightbox) {
    lightbox.classList.add('hidden');
  }
});

  
  
  